import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import type { SerializedEditorState } from 'lexical';
import { Lexical } from './lexical.tsx';

export type RichTextValue = SerializedEditorState;

type RichTextViewerProps = {
    content: RichTextValue | null | undefined;
};

export function RichTextViewer({ content }: RichTextViewerProps) {
    return (
        <Lexical
            content={content}
            contentEditable={<ContentEditable className="outline-hidden" style={{ userSelect: 'text' }} />}
        />
    );
}
